import type {Parser, Renderer, RendererExtension, RendererThis, Token, TokenizerExtension, Tokens} from 'marked';
import unicodeEmojiRegex from 'emoji-regex';

interface CustomRenderer extends Renderer {
    emoji?: (token: Token) => string;
}

interface CustomParser extends Parser {
    renderer: CustomRenderer;
}

interface CustomRendererThis extends RendererThis {
    parser: CustomParser;
}

const emojiRegex = /(?:^|\t|\s):[a-zA-Z0-9_+-]+:(?:\s|\t|$)/;
const startEmojiRegex = /^(:[a-zA-Z0-9_+-]+:)(?:\s|\t|$)/;

export const emojiExtension: TokenizerExtension & RendererExtension = {
    name: 'emoji',
    level: 'inline',
    start(src) {
        return src.match(emojiRegex)?.index;
    },
    tokenizer(src) {
        const match = src.match(startEmojiRegex);

        if (!match) {
            return;
        }

        const firstGroup = match[1];
        if (!firstGroup) {
            return;
        }

        return {
            type: 'emoji',
            raw: firstGroup,
            text: firstGroup,
        };
    },
    renderer(this: CustomRendererThis, token: Tokens.Generic) {
        if (this.parser.renderer.emoji) {
            return this.parser.renderer.emoji(token);
        }

        return this.parser.renderer.text(token as Tokens.Text);
    },
};

const unicodeRe = new RegExp(unicodeEmojiRegex().source);
const startUnicodeRe = new RegExp(`^(?:${unicodeEmojiRegex().source})`);

export const unicodeEmojiExtension: TokenizerExtension = {
    name: 'unicodeEmoji',
    level: 'inline',
    start(src) {
        return src.match(unicodeRe)?.index;
    },
    tokenizer(src) {
        const match = src.match(startUnicodeRe);

        if (!match) {
            return;
        }

        return {
            type: 'emoji',
            raw: match![0],
            text: match![0],
            isUnicode: true,
        };
    },
};
